import { ImpactStat } from '@/types/ui/public-page';

interface PublicImpactBarProps {
  gradient: string;
  stats: ImpactStat[];
}

const PublicImpactBar = ({ gradient, stats }: PublicImpactBarProps) => {
  return (
    <section className={`w-full ${gradient} py-10`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`grid grid-cols-${Math.min(stats.length, 4)} gap-8 text-white text-center`}>
          {stats.map((stat, index) => (
            <div key={index}>
              {stat.icon && (
                <div className="flex justify-center mb-2">
                  {stat.icon}
                </div>
              )}
              <div className="text-2xl font-bold mb-2">{stat.value}</div>
              <div className="text-sm opacity-90">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PublicImpactBar;